import $ from "jquery";

$(function () {
    $('html').on("click", '.rating-bar__btn--active', function () {
        const params = $(this).data('params');

        $.post($(this).attr('href'), params, function () {
            const ratingBarDiv = $("#ratingBarContainer");
            if (ratingBarDiv.length > 0)
                ratingBarDiv.load(`/help/ajax-renderer/rating-bar?id=${params.id}&type=${params.type}`);
        });

        return false;
    });

    $(document).on('click', '.rating-reason-btn__step1-reasoned', function (event) {
        event.preventDefault();

        $('.rating-feedback-form-label-reasoned').show();
        $('.rating-feedback-form-label-unreasoned').hide();

        $('.rating-form__step-1').hide();
        $('.rating-form__step-2').show();
        $('#ratingfeedbackform-reason').val(event.target.innerText);
    });

    $(document).on('click', '.rating-reason-btn__step1-unreasoned', function (event) {
        event.preventDefault();

        $('.rating-feedback-form-label-reasoned').hide();
        $('.rating-feedback-form-label-unreasoned').show();

        $('.rating-form__step-1').hide();
        $('.rating-form__step-3').show();
        $('#ratingfeedbackform-reason').val(event.target.innerText);
    });

    $(document).on('click', '.rating-reason-btn__step2-reasoned', function (event) {
        event.preventDefault();

        $('.rating-form__step-2').hide();
        $('.rating-form__step-3').show();
    });
});
